module.exports = __webpack_public_path__ + "static/img/103435.970b7c7e.png";